import { createAction, props } from '@ngrx/store';
import { CardTransaction } from 'src/app/models/card-transaction.model';
import { Card } from 'src/app/models/card.model';
import { TransactionHistoryList } from './../../../models/transaction-history.model';

// Page Actions
export const layoutSelectActiveCard = createAction(
  '[Layout Component] Active card selection',
  props<{ selectedCard: Card | null }>()
);

export const cardsComponentSelectActiveCard = createAction(
  '[Cards Component] Active card selection',
  props<{ selectedCard: Card | null }>()
);

export const loadTransactionHistorySuccess = createAction(
  '[Card Transactions Component] Load card transactions history success',
  props<{ cardTransactions: CardTransaction | null }>()
);

export const loadTransactionHistoryFailure = createAction(
  '[Card Transactions Component] Load card transactions history Failure',
  props<{ error: any }>()
);

export const setCardTransactionDetails = createAction(
  '[Account Transaction History] Set Active Account Transaction',
  props<{ cardTransactionDetails: TransactionHistoryList | null }>()
);

// API Actions
export const loadTransactionHistoryApi = createAction(
  '[Card Transactions Component API] Load card transactions history'
);
